export const timeFilter = [
  { label: 'Ran Today', value: 0 },
  { label: 'Last 7 days', value: 7 },
  { label: 'Last 30 days', value: 30 },
  { label: 'Custom', value: null },
];

export const channelFilter = [
  { label: 'Email', value: 'email' },
  { label: 'SMS', value: 'sms' },
  { label: 'Whatsapp', value: 'whatsapp' },
  { label: 'IVR', value: 'ivr' },
];

export const processModuleFilter = [
  { label: 'Workflow', value: 'workflow' },
  { label: 'Campaign', value: 'campaign' },
  { label: 'Customer', value: 'cust_mgmt' },
];

export const statusFilter = [
  { label: 'Initiated', value: 'Initiated' },
  { label: 'Success', value: 'Success' },
  { label: 'Failure', value: 'Failure' },
];

export const directionFilter = [
  { label: 'Outgoing', value: 'Outgoing' },
  { label: 'Incoming', value: 'Incoming' },
];
